import MonthlyReportPage from "./MonthlyReportPage.vue";
export default MonthlyReportPage;
